module.exports = __webpack_public_path__ + "img/login-primerodemayocalzado.c97b8f80.svg";